import React, { useEffect } from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import { ListGroupItem } from 'react-bootstrap';

import { usePolicyPlanTemplateContext } from 'contexts/PolicyPlanTemplateContext';
import Item from './Item';

export default function Index({ setTypeView }) {
  const { dispatch, actions, state } = usePolicyPlanTemplateContext();

  useEffect(() => {
    actions.load(dispatch);
  }, []);

  const onDragEnd = (result) => {
    actions.move(
      dispatch,
      state.templates,
      result.source.index,
      result.destination.index,
    );
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      <Droppable droppableId="droppable">
        {(provided, _snapshot) => (
          <>
            <ul
              {...provided.droppableProps}
              ref={provided.innerRef}
              className="list-group"
            >
              {state.templates == null && (
              <ListGroupItem align="center">Please, wait ...</ListGroupItem>
              )}

              {state.templates && state.templates.map((item, index) => (
                <Item key={item.id} index={index} item={item} setTypeView={setTypeView} />
              ))}
            </ul>

            {provided.placeholder}
          </>
        )}
      </Droppable>
    </DragDropContext>
  );
}
